// Modules
import React from 'react'

// Components
import { TemplateSingleBrand } from 'redesign/components/templates'
import { Wrapper, Title } from './styles'

// Application
import { useCPFLoginForm } from 'redesign/hooks/useCPFLoginForm'
import { CPFPhasedLoginForm } from '../CPFPhasedLoginForm'

export const CustomSinlgeBrand = () => {
    const { isAuthServiceDown } = useCPFLoginForm()
    const { isServiceDown } = isAuthServiceDown()

    return (
        <TemplateSingleBrand>
            <Wrapper>
                <Title>Acesse ou crie uma conta</Title>
            </Wrapper>
            <CPFPhasedLoginForm isServiceDown={isServiceDown} />
        </TemplateSingleBrand>
    )
}
